module.exports = require("handlebars/runtime")["default"];



//////////////////
// WEBPACK FOOTER
// ../node_modules/injectify/runtime.js
// module id = 15
// module chunks = 46 47